import type { OptimizelyData } from '../../sharedTypes';

export const OPTIMIZELY = {
  SET_OPTIMIZELY_SETTING: 'optimizely/set_optimizely_setting',
};

export type SetOptimizelySettingAction = {
  type: typeof OPTIMIZELY.SET_OPTIMIZELY_SETTING;
  optimizelyData: OptimizelyData;
};

export type OptimizelyAction = SetOptimizelySettingAction;

export function setOptimizelySetting(data: OptimizelyData) {
  return {
    type: OPTIMIZELY.SET_OPTIMIZELY_SETTING,
    payload: data,
  };
}
